module.exports = __webpack_public_path__ + "static/img/Cancer.190a68f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Cancer.svg
// module id = 1396
// module chunks = 0